import { bind } from "zeta-dom/domUtil";
import { IS_IOS } from "zeta-dom";
import { setTimeoutOnce } from "zeta-dom/util";
import dom, { textInputAllowed } from "zeta-dom/dom";
import $ from "jquery";

dom.root.style.overflow = 'hidden';
dom.root.style.height = '100%';

// fix root element height in iOS safari as 100% height does not match
// the actual viewport size when address bar is minimized
// whereas 100vh is definitely not working for other browsers
if (IS_IOS && window.ResizeObserver) {
    const ref = $('<div style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:-1;pointer-events:none">').appendTo(document.body)[0];
    new ResizeObserver(() => {
        let height = ref.getBoundingClientRect().height;
        if (dom.root.getBoundingClientRect().height !== height) {
            dom.root.style.height = height + 'px';
        }
    }).observe(ref);
}

// Chrome failed to display some texts occasionally after scrolling back to top
// if the page is too long (e.g. > 3000px), thinking that the region is still out-of-sight
if (navigator.userAgent.indexOf('Chrome') > 0) {
    const forceRepaint = function () {
        $('.scroll-fix').css('transform', 'translateZ(0)');
        // EAC-17819 fix error：SyntaxError: Unexpected token 's', "setImmedia"... is not valid JSON
        // setImmediate(() => {
            $('.scroll-fix').css('transform', 'none');
        // });
    };
    const handler = function (e: Zeta.ZetaEvent) {
        if (e.target.id === 'root') {
            setTimeoutOnce(forceRepaint);
        }
    };
    dom.on('scrollMove', handler);
    dom.on('scrollStop', handler);
}

bind(window, 'scroll focusin', function () {
    window.scrollTo(0, textInputAllowed(document.activeElement!) ? window.scrollY : 0);
});
